function attachRechargeListener() {
  const img = document.createElement('img');
  img.src = "//getpop.co/cdn/shop/t/83/assets/subscribe-arrows.svg?v=119888908512825879961765291182";
  img.alt = 'Subscription Icon';
  img.width = 30;
  img.height = 30;
  
  const widget = document.querySelector('recharge-subscription-widget');
  const addToCartButton = document.querySelector('button.product-form__submit');
  const addToCartButtonSpan = document.querySelector('.product-form__submit span');

  // default the colors of the PDP
  addToCartButton.style.backgroundColor = '#ef667d';
  addToCartButton.style.border = '#ef667d';
  addToCartButtonSpan.innerHTML = 'Add To Cart';

  if (!widget) return;

  // Wait for shadow root and internal content to load
  const checkInterval = setInterval(() => {
    const shadow = widget.shadowRoot;
    if (shadow) {
      const onetimeBtn = shadow.querySelector('.rc-selection__onetime');
      const subscriptionBtn = shadow.querySelector('.rc-purchase-option__subscription');

      if (onetimeBtn && subscriptionBtn) {

        onetimeBtn.addEventListener('click', () => {
          addToCartButton.style.backgroundColor = '#ef667d';
          addToCartButton.style.border = '#ef667d';
          addToCartButtonSpan.innerHTML = 'Add To Cart';
        });
        subscriptionBtn.addEventListener('click', () => {
          addToCartButton.style.backgroundColor = '#FFAE50';
          addToCartButton.style.border = '#FFAE50';
          addToCartButtonSpan.innerHTML = 'Subscribe ';
          addToCartButtonSpan.appendChild(img);
        });
        clearInterval(checkInterval); // Stop checking once found
      }
    }
  }, 400);
}

  // Wait until the page is loaded
  document.addEventListener('DOMContentLoaded', attachRechargeListener);